import { useEvent } from "@/context/event-context";
import forthecityLogo from "@/assets/forthecity-logo.png";

const Footer = () => {
  const { event } = useEvent();

  const venueName = event?.venue_name || "The Steam Plant";
  const venueAddress = event?.venue_address || "Dayton, OH";

  return (
    <footer data-nav-theme="light" className="bg-white py-[6vw] pb-8">
      <div className="max-w-[1600px] mx-auto px-[4vw]">
        {/* Logo */}
        <div className="flex justify-center mb-16">
          <img src={forthecityLogo} alt="For The City Entertainment" width={1920} height={1114} className="h-20 w-auto object-contain" />
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 border-t border-ink border-b py-12 mb-12 text-left">
          <div className="flex flex-col gap-4">
            <span className="font-heading text-[0.7rem] uppercase tracking-[0.2em] font-extrabold text-foreground">
              Inquiries
            </span>
            <a href="mailto:4thecityent@gmail.com" className="font-serif-elegant text-lg italic text-foreground no-underline hover:opacity-70 transition-opacity">
              4thecityent@gmail.com
            </a>
            <span className="font-serif-elegant text-lg italic text-foreground">
              +1 (937) 266-5786
            </span>
          </div>

          <div className="flex flex-col gap-4">
            <span className="font-heading text-[0.7rem] uppercase tracking-[0.2em] font-extrabold text-foreground">
              Location
            </span>
            <span className="font-serif-elegant text-lg italic text-foreground">
              {venueName}
            </span>
            <span className="font-serif-elegant text-lg italic text-foreground">
              {venueAddress}
            </span>
          </div>

          <div className="flex flex-col gap-4">
            <span className="font-heading text-[0.7rem] uppercase tracking-[0.2em] font-extrabold text-foreground">
              Social
            </span>
            <a href="https://www.instagram.com/p/DVw4s0TEgh7/" target="_blank" rel="noopener noreferrer" className="font-serif-elegant text-lg italic text-foreground no-underline hover:opacity-70 transition-opacity">
              Instagram
            </a>
            <a href="https://www.facebook.com/ForTheCityEnt/" target="_blank" rel="noopener noreferrer" className="font-serif-elegant text-lg italic text-foreground no-underline hover:opacity-70 transition-opacity">
              Facebook
            </a>
            <a href="https://www.youtube.com/channel/UCN8gSdr-obg905aNDC4PPCw" target="_blank" rel="noopener noreferrer" className="font-serif-elegant text-lg italic text-foreground no-underline hover:opacity-70 transition-opacity">
              YouTube
            </a>
          </div>
        </div>

        <p className="text-center font-heading text-[0.7rem] uppercase tracking-[0.2em] font-extrabold text-foreground/70">
          © {new Date().getFullYear()} For The City Entertainment
        </p>
      </div>
    </footer>
  );
};

export default Footer;
